module.exports = __webpack_public_path__ + "static/img/01.c228740.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/01.png
// module id = oEdA
// module chunks = 2